import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../../../redux/selectors/resources';

interface Props {
  scrollToNestedComponent: () => void;
}

export const ScoreExchange = ({scrollToNestedComponent}: Props) => {
  const content = useSelector(contentSelector());
  return <View content={content} scrollToNestedComponent={scrollToNestedComponent} />;
};
